//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Slider from '@/components/common/Slider'
import TeacherPhotoStyled from '@/components/common/TeacherPhotoStyled.vue'
export default {
  name: 'TeachersSection',
  components: {
    Slider,
    TeacherPhotoStyled,
  },
  data() {
    return {
      sliderOptions: {
        slidesPerView: 3,
        loop: false,
        spacing: 20,
        breakpoints: {
          '(max-width: 1280px)': {
            slidesPerView: 2,
          },
          '(max-width: 860px)': {
            slidesPerView: 1,
          },
        },
      },
      hideNav: true,
    }
  },
  computed: {
    teachers() {
      return this.$getTeachers() || []
    },
  },
  mounted() {
    if (window.innerWidth < 640 && this.teachers.length > 1) {
      this.hideNav = false
    } else {
      this.hideNav = this.teachers > 3
    }
  },
  methods: {
    teacherName(fullName, firstName) {
      if (firstName !== undefined && firstName.length > 0) {
        return firstName
      }

      return fullName.split(' ')[1]
    },
    teacherPhoto(url) {
      if (url) {
        return url
      }

      return require('@/assets/img/redesign/common/teacher-photo.png')
    },
    getDirection() {
      return this.$direction()
    },
  },
}
